export interface DepositInsuranceContext {
  taskId: number;
  periodStart?: string;
  periodEnd?: string;
  rowCount: number;
  validCount: number;
  failCount: number;
  totalAmountCents: number;
  depositAmountCents: number;
  insuranceAmountCents: number;
  depositCount: number;
  insuranceCount: number;
  sourceFileName?: string;
  submitterName?: string;
}

const num = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
const str = (v: unknown): string | undefined => (typeof v === 'string' && v ? v : undefined);

/** 解析保证金/保险审批实例的 contextJson；解析失败返回 null，数值缺省为 0 */
export function parseDepositInsuranceContext(contextJson?: string | null): DepositInsuranceContext | null {
  if (!contextJson) return null;
  try {
    const raw = JSON.parse(contextJson);
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
    return {
      taskId: num(raw.taskId),
      periodStart: str(raw.periodStart),
      periodEnd: str(raw.periodEnd),
      rowCount: num(raw.rowCount),
      validCount: num(raw.validCount),
      failCount: num(raw.failCount),
      totalAmountCents: num(raw.totalAmountCents),
      depositAmountCents: num(raw.depositAmountCents),
      insuranceAmountCents: num(raw.insuranceAmountCents),
      depositCount: num(raw.depositCount),
      insuranceCount: num(raw.insuranceCount),
      sourceFileName: str(raw.sourceFileName),
      submitterName: str(raw.submitterName),
    };
  } catch {
    return null;
  }
}
